module.exports = __webpack_public_path__ + "static/media/mastercard-logo.5c71b79b.jpg";